














































































import { Component, Vue, Watch } from "vue-property-decorator"
import { mapGetters, mapState } from "vuex"
import { debounce, isArray } from "lodash"

@Component({
  computed: {
    ...mapState("CandidateProfile", {
      candidateProfile: "candidateProfile",
      candidateProfileItems: "candidateProfileItems",
    }),
    ...mapGetters("CandidateProfile", {
      retrieveDataFromProfile: "retrieveDataFromProfile",
    }),
  },
})
export default class QuestionGroupPreviewCandidateProfile extends Vue {
  candidateProfile!: Model | null
  candidateProfileItems!: {
    compute: [];
    standard: [];
  }

  previewCandidateProfiles = []
  search = ""
  isChanged = false

  debounceFetch!: () => void

  @Watch("search")
  watchSearch() {
    this.debounceFetch()
  }

  get selectedCandidateProfile() {
    return this.candidateProfile
  }
  set selectedCandidateProfile(v) {
    this.$store.commit("CandidateProfile/SET_CANDIDATE_PROFILE", v)
  }

  get candidateProfileComputedItems() {
    return this.candidateProfileItems.compute
  }

  get candidateProfileQuestionGroups() {
    return this.candidateProfileItems.standard
  }

  async mounted() {
    this.debounceFetch = debounce(() => {
      this.search &&
        this.search != this.selectedCandidateProfile?.preview_name &&
        this.searchForCandidateProfile()
    }, 500)

    if (!this.candidateProfileItems) {
      await this.$store.dispatch("CandidateProfile/fetchCandidateProfileItems")
    }

    this.searchForCandidateProfile()
  }

  async searchForCandidateProfile() {
    this.previewCandidateProfiles = await this.$store.dispatch(
      "CandidateProfile/fetchList",
      {
        params: {
          search_name: this.search,
          is_for_preview: 1,
          per_page: 50,
        },
      }
    )
  }

  async createNew() {
    this.$store.commit("CandidateProfile/INIT_CANDIDATE_PROFILE", {})
  }

  async save() {
    if (!this.selectedCandidateProfile?.object_id) {
      await this.$store.dispatch("CandidateProfile/createForPreview", {
        preview_name: this.selectedCandidateProfile?.preview_name,
        items: this.selectedCandidateProfile,
      })
    } else {
      await this.$store.dispatch("CandidateProfile/updateForPreview", {
        object_id: this.selectedCandidateProfile.object_id,
        payload: {
          preview_name: this.selectedCandidateProfile?.preview_name,
          items: this.selectedCandidateProfile,
        },
      })
    }
    this.isChanged = false

    await this.searchForCandidateProfile()
  }

  retrieveCandidateProfile() {
    this.$store.commit(
      "CandidateProfile/SET_CANDIDATE_PROFILE",
      this.selectedCandidateProfile
    )
  }

  // Save the new value as string
  handleAutoCompleteChange(value, key) {
    if (isArray(value) && this.selectedCandidateProfile) {
      this.selectedCandidateProfile["cp_" + key] = value.join(",")
    } else if (this.selectedCandidateProfile) {
      this.selectedCandidateProfile["cp_" + key] = value
    }
    this.isChanged = true
  }

  // Check question form type whether is a multiple selection type or not
  isMultipleType(formType) {
    return ["checkbox", "dropdown_multiple"].includes(formType)
  }

  // Get the profile data determined by question type
  getProfileData(value, question) {
    if (this.isMultipleType(question.form_type)) {
      return this.toArray(value)
    }
    return value
  }

  // Convert the value to array
  toArray(value) {
    if (!value) {
      return value
    }
    return value.split(",")
  }
}
